import React from "react";
import "../../Css/SummaryCard.css";

function SummaryCard({ tipo, img, price, quantity,cor,size,Produto,taxa }) {
  return (


    // --------------------------------------

    <div className="summaryCard">
       <div className="summaryImage"> 
        <img src={img} alt={Produto} />
         </div> <div className="summaryInfo"> 
          <h4 className="summaryTitle">{Produto}</h4>
           <div className="summaryMeta"> 
            <span>Cor: <b>{cor}</b></span> <span>Tamanho: <b>{size}</b>
            </span> </div> <div className="summaryFooter">
               <span className="summaryQty">Qtd: {quantity}</span> 
               <span className="summaryPrice">Kz {((price * quantity)+(taxa*quantity)).toLocaleString()}</span> 
               </div> </div>
                </div>
  );
}

export default SummaryCard;
